import { Reveal, SectionTag, SectionTitle } from "./shared";
import { ShieldCheck, FileText, Building2, Landmark, MapPin, CalendarClock, HardHat, Scale } from "lucide-react";

const TRUST_ITEMS = [
  { icon: ShieldCheck, label: "RERA Information", desc: "Registration details referenced for every project we present." },
  { icon: FileText, label: "Project Documents", desc: "Approvals, layouts and developer paperwork shared on request." },
  { icon: Building2, label: "Developer Information", desc: "Official developer sources, not broker hearsay." },
  { icon: Landmark, label: "Government Sources", desc: "YEIDA, airport authority and PIB announcements tracked." },
  { icon: MapPin, label: "Location Maps", desc: "Ground-truthed sector and corridor orientation." },
  { icon: CalendarClock, label: "Price Update Dates", desc: "Quotes carry a date - stale pricing is called out." },
  { icon: HardHat, label: "Construction Status", desc: "Operational, under development, announced or proposed - always labelled." },
  { icon: Scale, label: "Transparent Disclaimers", desc: "No guaranteed returns. Honest risk framing on every recommendation." },
];

export function Trust() {
  return (
    <section className="relative py-28 lg:py-40 bg-[#0D0D0D]" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>Trust</SectionTag>
        <div className="grid lg:grid-cols-2 gap-8 items-end mb-14">
          <SectionTitle>Invest With Information, <span className="text-gold-gradient italic">Not Hype.</span></SectionTitle>
          <Reveal delay={0.15}>
            <span data-testid="verified-badge" className="inline-flex items-center gap-2 px-4 py-2 border border-[#D4AF37]/50 rounded-full text-[10px] uppercase tracking-[0.25em] text-[#F3E5AB]">
              <ShieldCheck size={14} className="text-[#D4AF37]" /> Verified Information
            </span>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-24" data-testid="trust-grid">
          {TRUST_ITEMS.map((t, i) => (
            <Reveal key={t.label} delay={i * 0.05}>
              <div className="p-6 border border-[#D4AF37]/12 bg-[#101010] rounded-[2px] h-full hover:border-[#D4AF37]/40 transition-colors duration-500">
                <t.icon size={20} strokeWidth={1.4} className="text-[#D4AF37] mb-4" />
                <p className="text-sm text-[#F5F5F0] mb-1.5">{t.label}</p>
                <p className="text-[12px] text-[#71717A] leading-relaxed">{t.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <SectionTag>Client Voices</SectionTag>
        <div className="grid lg:grid-cols-3 gap-5" data-testid="testimonials-grid">
          {[1, 2, 3].map((n) => (
            <Reveal key={n} delay={n * 0.08}>
              <div className="p-8 border border-dashed border-[#D4AF37]/25 rounded-[2px] h-full flex flex-col" data-testid={`testimonial-placeholder-${n}`}>
                <span className="font-serif-lux text-6xl text-[#D4AF37]/25 leading-none mb-4">&ldquo;</span>
                <p className="text-sm text-[#71717A] italic leading-relaxed flex-1">
                  Genuine client review forthcoming. We publish only verified testimonials -
                  with name, property type, experience and date - once clients consent to share them.
                </p>
                <div className="gold-hairline my-5" />
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#52525b]">Client Name &bull; Property Type &bull; Date</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
